import { FormControlLabel, Switch} from "@mui/material"

export default function Toggle({label, value, onChange}){

    return <FormControlLabel 
        label={label}
        control={<Switch checked={value ? true : false}/>}
        onChange={onChange}
    />
} 